<script>

	import { onMount, onDestroy, tick } from 'svelte';
	import { writable } from 'svelte/store';

	import { v4 as uuid } from 'uuid';

	import SessionDetails from './Session/SessionDetails.svelte';
	import Interactions from "./Session/Interactions.svelte";

	import { busy, bigError, agenda, session, syncClient, syncChannels, epoch, event } from '../lib/stores.js';
	import { getServerData } from '../lib/prelude.js';

	export let stageInteractions = true;

	let mounted = false;
	let attendeeNotifications;

	let playback;
	let livestreamStatus;
	let token;
	let ll;
	let captions;
	let rtmp;

	let sessionRef;

	onMount(async () => {

		// console.log('mounting session', $session.ref);

		await getSessionData(true);
		await tick();
		mounted = true;

		stageInteractions = ($session && $session.app && $session.app.interactions && $session.app.interactions.length) ? true : false;

		try {
			attendeeNotifications = await $syncClient.list($syncChannels.attendee);
			attendeeNotifications.on('itemAdded', syncNotificationAdded);
		} catch (e) {
			console.log("Sync error", e, $syncChannels.attendee);
		}

	});

	onDestroy(() => {
		if (attendeeNotifications) attendeeNotifications.close();
	});

	function syncNotificationAdded(message) {
		// console.log("(session) attendee notification", message);
		if (message && message.item && message.item.data && message.item.data.type) {
			if (message.item.data.sessionRef && (message.item.data.sessionRef == $session.ref)) {
				if (message.item.data.type == 'poll') {
					// console.log("Setting pollResponses (message.item.data.poll // message.item.data.response)");
					$session.pollResponses[message.item.data.poll] = message.item.data.response;
					$session = $session;
				}
			}
		}
	}

	async function getSessionData(m) {
		if (m || mounted) {

			$busy = true;

			const sessionData = await getServerData('onstage/session', {
				session: $session.ref
			});

			if (!$bigError) {

				sessionRef = $session.ref;

				$busy = false;

				$session.syncChannel = sessionData.syncChannel;
				// $session.controlChannel = sessionData.controlChannel;
				// if (sessionData.privateChannel) $session.privateChannel = sessionData.privateChannel;

				$session.pollResponses = sessionData.pollResponses ? sessionData.pollResponses : {};

			}

		}
	}

	$: if ($agenda) {
		getSessionData();
	}

	$: if ($session && ($session.ref != sessionRef)) {
		getSessionData();
	}

</script>

<style>
	div {
		position: absolute;
		inset: 0;
		display: flex;
		flex-direction: column;
		padding: 0;
	}
</style>

{#if mounted}
	<div>
		<SessionDetails/>
		{#if stageInteractions}
			<Interactions/>
		{/if}
	</div>
{/if}
